<template>
  <div>
    <section class="con3">
      <div class="container inner">
        <ul>
          <li>
            <div class="list-wrap">
              <div class="left-svg-wrap">
                <svg
                  viewBox="0 0 100 100"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                >
                  <circle
                    cx="50"
                    cy="50"
                    r="45"
                    stroke-width=".6"
                    class="left-circle"
                  ></circle>
                  <circle
                    cx="50"
                    cy="50"
                    r="45"
                    stroke-width=".6"
                    class="left-circle"
                  ></circle>
                  <circle
                    cx="50"
                    cy="50"
                    r="45"
                    stroke-width=".6"
                    class="left-circle"
                  ></circle>
                </svg>
              </div>
              <div class="text-wrap">
                <p>Mission</p>
                <p>리더의 성취와 의식 진전을<br />통해 일터와 사회의 변화</p>
              </div>
            </div>
          </li>
          <li>
            <div class="list-wrap">
              <div class="right-svg-wrap">
                <svg
                  viewBox="0 0 106 100"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  stroke="#fff"
                  stroke-width=".6"
                >
                  <ellipse cx="53" cy="90" rx="50" ry="8"></ellipse>
                </svg>
                <svg
                  viewBox="0 0 106 100"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  stroke="#fff"
                  stroke-width=".6"
                >
                  <ellipse cx="53" cy="10" rx="50" ry="8"></ellipse>
                  <ellipse cx="53" cy="10" rx="50" ry="8"></ellipse>
                  <ellipse cx="53" cy="10" rx="50" ry="8"></ellipse>
                  <ellipse cx="53" cy="10" rx="50" ry="8"></ellipse>
                </svg>
              </div>
              <div class="text-wrap">
                <p>Vision</p>
                <p>
                  리더의 일과 삶의 문제를 혁신적으로<br />변화시키는 명상
                  커뮤니티 조성
                </p>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </section>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
section {
  display: block;
}

img {
  display: block;
  width: 100%;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
}

.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}

// con3
.con3 {
  background-color: #998465;
  overflow: hidden;

  .inner {
    ul {
      display: grid;
      grid-template-columns: repeat(1, 1fr);

      @media screen and (min-width: 1200px) {
        grid-template-columns: repeat(2, 1fr);
      }

      li {
        width: 100%;
        padding: 70px 18px;

        @media screen and (min-width: 1200px) {
          padding: 150px 0;
        }

        &:nth-of-type(1) {
          border-bottom: 1px solid #fff;

          @media screen and (min-width: 1200px) {
            padding-right: 70px;
            border-bottom: none;
            border-right: 1px solid #fff;
          }
        }

        &:nth-of-type(2) {
          @media screen and (min-width: 1200px) {
            padding-left: 70px;
          }
        }

        .list-wrap {
          position: relative;

          .left-svg-wrap {
            svg {
              transform: rotate(-15deg);

              .left-circle {
                transform-origin: 50% 50%;
                animation: mission 2s infinite cubic-bezier(0.76, 0, 0.24, 1);

                &:nth-of-type(1) {
                  stroke: rgba(255, 255, 255, 0.3);
                  animation-delay: calc(1s / 4);
                }
                &:nth-of-type(2) {
                  stroke: rgba(255, 255, 255, 0.3);
                  animation-delay: calc(2s / 4);
                }
                &:nth-of-type(3) {
                  stroke: #fff;
                }
              }
            }
          }

          .right-svg-wrap {
            position: relative;

            svg {
              &:nth-of-type(1) {
                ellipse {
                  stroke: rgba(255, 255, 255, 0.2);
                }
              }

              &:nth-of-type(2) {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 100%;
                height: 100%;

                ellipse {
                  animation: vision 2.4s infinite linear both;

                  &:nth-of-type(1) {
                    animation-delay: calc(1s * 0.8);
                  }

                  &:nth-of-type(2) {
                    animation-delay: calc(2s * 0.8);
                  }
                }
              }
            }
          }

          .text-wrap {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 100%;

            p {
              text-align: center;
              color: #fff;

              &:nth-of-type(1) {
                font-size: 30px;
                font-weight: 700;
                margin-bottom: 30px;

                @media screen and (min-width: 1200px) {
                  font-size: 46px;
                }
              }

              &:nth-of-type(2) {
                font-size: 18px;

                @media screen and (min-width: 1200px) {
                  font-size: 30px;
                }
              }
            }
          }
        }
      }
    }
  }
}

@keyframes mission {
  from {
    transform: scaleX(1);
  }

  to {
    transform: scaleX(-1);
  }
}

@keyframes vision {
  0% {
    transform-origin: 0% 0%;
    transform: scale(1) translate3d(0, 0, 0);
    opacity: 1;
  }
  50% {
    transform-origin: 50% 80%;
    transform: scale(1) translate3d(0%, 58%, 0);
    opacity: 0.5;
  }
  60% {
    transform-origin: 50% 80%;
    transform: scale(1) translate3d(0%, 58%, 0);
    opacity: 0.1;
  }
  100% {
    transform-origin: 50% 80%;
    transform: scale(1) translate3d(0%, 100%, 0);
    opacity: 0;
  }
}
</style>
